exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sas-noticeemail-container[data-v-502ca94f] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.sas-noticeemail-container .row[data-v-502ca94f] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: 0.260417rem;\n  margin-bottom: 0.104167rem;\n}\n.sas-noticeemail-container .row .label[data-v-502ca94f] {\n  width: 1.041667rem;\n}\n.sas-noticeemail-container .row .select[data-v-502ca94f] {\n  width: 1.041667rem;\n}", ""]);

// exports
